// extracted by mini-css-extract-plugin
module.exports = {"root":"root--57E0H","sidebar":"sidebar--drZUE","content":"content--qKnPk"};